/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'left-header.scss' instead.
import { css } from 'lit';
export default css `:host{margin-top:0!important}@media (max-width:1199.98px){:host ul{display:grid;grid-gap:var(--cipublic-size-m)}}`;
//# sourceMappingURL=left-header.scss.js.map